
import Vue from "vue";
import { store } from "@/store";
import { formatDate } from "@/services/date";
import TagInput from "./TagInput.vue";
import { api, BudgetBucket } from "../services/api";

export type DefaultExpense = {
    amount: number;
    description: string;
    date: string;
    id?: number;
    tags: string[];
    sensitive: boolean;
    isSplitChild?: boolean;
    budgetBucketOverrideId?: number | null;
};

const defaultExpense = (): DefaultExpense => {
    const today = formatDate(new Date());
    return {
        amount: 0.0,
        description: "",
        date: today,
        tags: [],
        sensitive: false
    };
};

export type ExpenseEventData = {
    amount: number;
    description: string;
    date?: string;
    id?: number;
    tags: string[];
    sensitive: boolean;
    setBudgetBucketOverride?: boolean;
    budgetBucketOverrideId?: number | null;
};

const normalizeExpense = (expense: DefaultExpense): DefaultExpense => ({
    ...expense,
    amount: expense.amount / 100,
});

export default Vue.extend({
    name: "Home",
    components: {
        TagInput
     },
    props: {
        dateEnabled: {
            default: true,
            type: Boolean,
        },
        defaultExpense: {
            required: false,
            default: defaultExpense,
            type: Object as () => DefaultExpense,
        },
        showCancel: {
            required: false,
            default: false,
        },
        amountEnabled: {
            required: false,
            default: true,
            type: Boolean,
        },
        budgetBuckets: {
            required: false,
            default: () => [],
            type: Array as () => BudgetBucket[],
        },
    },
    data() {
        return {
            expense: normalizeExpense(defaultExpense()),
            day: 0,
            autoTag: false,
            selectedBudgetBucketId: null as number | null,
            automaticBucketValue: null as number | null,
            setup: () => {
                //empty at first
            }
        };
    },
    watch: {
        defaultExpense(val) {
            this.expense = normalizeExpense({ ...val });
            this.selectedBudgetBucketId = val.budgetBucketOverrideId ?? null;
            this.setup();
        },
        day(val, old) {
            const day = new Date(this.expense.date).getDate();
            if (val !== old && val !== day) {
                const date = new Date(this.expense.date);
                date.setDate(val);
                console.log(val, date.getDate());
                if (date.getDate() == val) {
                    this.expense.date = formatDate(date);
                }
            }
        },
        currentDate(val) {
            const day = new Date(val).getDate();
            if (day !== this.day) {
                this.day = day;
            }
        }
    },
    mounted() {
        this.expense = normalizeExpense({ ...this.defaultExpense });
        this.selectedBudgetBucketId = this.defaultExpense.budgetBucketOverrideId ?? null;
        const day = new Date(this.expense.date).getDate();
        this.day = day;
        this.setup();
    },
    methods: {
        storeSetup(callback: () => void) {
            this.setup = callback;
        },
        focusNumber() {
            if (!this.amountEnabled) {
                return;
            }
            const input = this.$refs["number"] as HTMLInputElement;
            input.select();
        },
        addTag(tag: string) {
            if (!this.expense.tags.includes(tag)) {
                this.expense.tags.push(tag);
            }
        },
        removeTag(tag: string) {
            this.expense.tags = this.expense.tags.filter((t) => t !== tag);
        },
        async emitExpense() {
            const event: ExpenseEventData = {
                amount: this.expense.amount,
                description: this.expense.description,
                date: this.dateEnabled ? this.expense.date : undefined,
                id: this.expense.id,
                tags: this.expense.tags,
                sensitive: this.expense.sensitive,
                setBudgetBucketOverride: this.budgetBuckets.length > 0,
                budgetBucketOverrideId: this.selectedBudgetBucketId,
            };
            if (this.autoTag) {
                if (!event.date) {
                    alert("Invalid date");
                    return;
                }
                const suggested = await api.suggestTags(
                    {...event, date: new Date(event.date)}
                //     {
                //     amount: expense.rawAmount / 100,
                //     description: mainExpense.description,
                //     date: mainExpense.date,
                //     tags: mainExpense.tags,
                //     sensitive: mainExpense.sensitive,
                // }
                );
                event.tags = suggested;
            }

            this.$emit("expense-received", event);
            this.resetExpense()
        },
        resetExpense() {
            this.$set(this, "expense", { ...this.defaultExpense });
            this.selectedBudgetBucketId = this.defaultExpense.budgetBucketOverrideId ?? null;
            this.autoTag = false;
            this.setup();
        },
        emitCancel() {
            this.$emit("cancel");
        },
        emitRemove() {
            this.$emit("expense-removed", this.expense.id);
            this.resetExpense();
        }
    },
    computed: {
        user() {
            return store.user;
        },
        deleteEnabled() {
            return this.showCancel;
        },
        currentDate(): string {
            return this.expense.date;
        }
    },
});
